<template>
  <div class="row align-items-center contact-item">
    <div class="col-3 contact-item__contact">
      <span>{{ contact.last_name }}</span>
      <span>{{ contact.first_name }}</span>
    </div>
    <div :class="{ 'col-9': !$slots['controls'], 'col-8': $slots['controls'] }">
      <contact-method :item="method" />
    </div>
    <div v-if="$slots['controls']" class="col-1">
      <div class="row">
        <slot name="controls"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import ContactMethod from '../item';

  export default {
    components: { ContactMethod },

    props: {
      contact: {
        type: Object,
        default: () => ({})
      },

      method: {
        type: Object,
        default: () => ({})
      }
    }
  };
</script>

<style lang="scss">
  .contact-item {
    padding: 10px 0;
    border-bottom: 1px solid #f5f6f8;

    &:nth-last-child(1) {
      border-bottom: none;
    }

    &__contact {
      color: $blue-grey-light;
      line-height: 18px;
      display: flex;
      flex-direction: column;
    }
  }
</style>
